import { logXandrAction } from '@/api'

const module = 'XANDR_WORKBENCH_ACTIONS_'
export const STORE_NAME = 'xandr_workbench'

export const SET_INTERFACE = module + 'SET_INTERFACE'
export const SEND_DOWN_STREAM = module + 'SEND_DOWN_STREAM'
export const SET_ENABLE_UPDATE_INSIGHTS = module + 'SET_ENABLE_UPDATE_INSIGHTS'
export const SET_ENABLE_UPDATE_TARGET_HEADER_DATA = module + 'SET_ENABLE_UPDATE_TARGET_HEADER_DATA'
export const SHOW_UE_MODAL = module + 'SHOW_UE_MODAL'
export const SET_LOADING_INSIGHTS = module + 'SET_LOADING_INSIGHTS'
export const LOG_XANDR_ACTION = module + 'LOG_XANDR_ACTION'
export const TOGGLE_MOCK_DATA = module + 'TOGGLE_MOCK_DATA'
export const SET_QUERY = module + 'SET_QUERY'
export const RESET = module + 'RESET'
export const SHOW_SAVING_LIVE_DIGITAL_PROMPT = 'SHOW_SAVING_LIVE_DIGITAL_PROMPT'
export const SET_CONTROL_URL = 'SET_CONTROL_URL'
export const SET_QUERY_ERRORED_OUT = module + 'SET_QUERY_ERRORED_OUT'
export const SET_TRAITS = module + 'SET_TRAITS'
export const SHOW_MODELING_MODAL = module + 'SHOW_MODELING_MODAL'

const actions = {
  [SHOW_MODELING_MODAL]: (context) => {
    context.commit(SHOW_MODELING_MODAL)
  },
  [SET_INTERFACE]: (context, inter) => {
    context.commit(SET_INTERFACE, inter)
  },
  // this is the Xandr Send Downstream created for the purpose of the
  [SEND_DOWN_STREAM]: (context) => {
    context.state.interface.__sendDownStream({
      context,
      targetId: context.getters.newWorkbenchTarget.id
    })
  },
  [SET_ENABLE_UPDATE_INSIGHTS]: (context, setValue) => {
    context.commit(SET_ENABLE_UPDATE_INSIGHTS, setValue)
  },
  [SET_ENABLE_UPDATE_TARGET_HEADER_DATA]: (context, setValue) => {
    context.commit(SET_ENABLE_UPDATE_TARGET_HEADER_DATA, setValue)
  },
  [SHOW_UE_MODAL]: (context) => {
    context.commit(SHOW_UE_MODAL)
  },
  [SHOW_SAVING_LIVE_DIGITAL_PROMPT]: (context) => {
    context.commit(SHOW_SAVING_LIVE_DIGITAL_PROMPT)
  },
  [SET_LOADING_INSIGHTS]: (context, value) => {
    context.commit(SET_LOADING_INSIGHTS, value)
  },
  [TOGGLE_MOCK_DATA]: (context, value) => {
    context.commit(TOGGLE_MOCK_DATA, value)
  },
  [SET_QUERY]: (context, value) => {
    context.commit(SET_QUERY, value)
  },
  [RESET]: (context) => {
    context.commit(RESET)
  },
  [LOG_XANDR_ACTION]: async (context, value) => {
    await logXandrAction(value)
    context.commit(LOG_XANDR_ACTION, value)
  },
  [SET_QUERY_ERRORED_OUT]: (context, value) => {
    context.commit(SET_QUERY_ERRORED_OUT, value)
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/app/appLogic/workbench/Xandr/store/actions.js